import themeFactory from './themes/factory'

class ContinuousBar {
  constructor ($, $container, options) {
    this.$ = $
    this.$container = $container
    this.options = options
    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()

    this.$bar = this.$container.find(this.selector.continuousBar)
    this.$titleLink = this.$container.find(this.selector.continuousBarTitleLink)

    this.$container.on('click', this.selector.continuousBarCloseButton, evt => {
      this.$bar.css('display', 'none')
    })
  }
  show (title, link) {
    this.$titleLink.text(title)
    this.$titleLink.prop('href', link)
    this.$bar.css('visibility', 'visible')
  }
}

export default ContinuousBar
